function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M112.418 7.81674C70.4346 -9.49906 20.0803 20.2705 8.42536 44.8258C-19.5611 103.789 29.3463 131 50.8615 121.047C59.8434 116.892 67.1802 109.796 74.271 102.892C84.9178 92.6148 99.0241 86.6922 113.817 86.2887C125.209 86.0269 136.547 89.0838 147.907 88.1862C159.266 87.2886 169.301 71.6216 168.993 60.2305C168.523 42.8442 157.438 26.3844 112.418 7.81674Z",
  fill: "#9FA9E6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M141.326 6.27734H27.6745C23.9058 6.27734 20.8506 9.33253 20.8506 13.1013V102.538C20.8506 106.307 23.9058 109.362 27.6745 109.362H141.326C145.095 109.362 148.15 106.307 148.15 102.538V13.1013C148.15 9.33253 145.095 6.27734 141.326 6.27734Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M141.326 109.576H27.6742C25.8082 109.574 24.0193 108.831 22.6999 107.512C21.3805 106.192 20.6383 104.404 20.6362 102.538V13.1007C20.6383 11.2347 21.3805 9.44576 22.6999 8.1263C24.0193 6.80684 25.8082 6.06463 27.6742 6.0625H141.326C143.192 6.06463 144.981 6.80684 146.3 8.1263C147.619 9.44576 148.362 11.2347 148.364 13.1007V102.538C148.362 104.404 147.619 106.192 146.3 107.512C144.981 108.831 143.192 109.574 141.326 109.576V109.576ZM27.6742 6.49073C25.9217 6.49274 24.2417 7.1898 23.0025 8.42897C21.7634 9.66815 21.0664 11.3482 21.0645 13.1007V102.538C21.0664 104.29 21.7634 105.97 23.0025 107.209C24.2417 108.448 25.9217 109.145 27.6742 109.148H141.326C143.078 109.145 144.758 108.448 145.997 107.209C147.236 105.97 147.933 104.29 147.935 102.538V13.1007C147.933 11.3482 147.236 9.66815 145.997 8.42897C144.758 7.1898 143.078 6.49274 141.326 6.49073H27.6742Z",
  fill: "#292A2E"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M148.15 13.0988V26.0387H20.8511V13.0988C20.8508 12.2024 21.0272 11.3148 21.3701 10.4867C21.7129 9.65854 22.2156 8.90606 22.8494 8.27223C23.4831 7.6384 24.2356 7.13565 25.0637 6.79269C25.8918 6.44973 26.7794 6.27329 27.6757 6.27344H141.326C143.136 6.27374 144.872 6.99299 146.152 8.27298C147.431 9.55296 148.15 11.2888 148.15 13.0988V13.0988Z",
  fill: "#6462F3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M148.38 26.2679H20.6213V13.0981C20.6231 11.2277 21.3669 9.43435 22.6894 8.11166C24.0119 6.78896 25.8052 6.04498 27.6756 6.04297H141.326C143.197 6.04528 144.989 6.78939 146.312 8.11205C147.634 9.4347 148.378 11.2279 148.38 13.0981V26.2679ZM21.0815 25.8082H147.92V13.0981C147.918 11.3498 147.223 9.67351 145.987 8.43706C144.751 7.2006 143.075 6.50495 141.326 6.50269H27.6756C25.9271 6.50464 24.2507 7.20017 23.0144 8.43667C21.7781 9.67316 21.0828 11.3496 21.0811 13.0981L21.0815 25.8082Z",
  fill: "#367CFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.916 12.9787V3.42625C53.916 1.66774 52.4905 0.242188 50.732 0.242188C48.9734 0.242188 47.5479 1.66774 47.5479 3.42625V12.9787C47.5479 14.7372 48.9734 16.1627 50.732 16.1627C52.4905 16.1627 53.916 14.7372 53.916 12.9787Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M50.731 16.3767C49.8302 16.3755 48.9666 16.017 48.3297 15.38C47.6928 14.7429 47.3346 13.8792 47.3336 12.9784V3.42624C47.3299 2.97763 47.4151 2.53274 47.5842 2.11721C47.7533 1.70169 48.0031 1.32376 48.319 1.00524C48.6349 0.686713 49.0107 0.433892 49.4249 0.26136C49.839 0.0888281 50.2832 0 50.7318 0C51.1804 0 51.6246 0.0888281 52.0387 0.26136C52.4528 0.433892 52.8287 0.686713 53.1446 1.00524C53.4605 1.32376 53.7102 1.70169 53.8794 2.11721C54.0485 2.53274 54.1337 2.97763 54.13 3.42624V12.9784C54.129 13.8795 53.7706 14.7434 53.1333 15.3805C52.4961 16.0177 51.6321 16.3759 50.731 16.3767V16.3767ZM50.731 0.456183C49.9435 0.457035 49.1886 0.770224 48.6318 1.32703C48.075 1.88384 47.7618 2.63879 47.7609 3.42624V12.9784C47.7575 13.3706 47.8317 13.7597 47.9795 14.123C48.1272 14.4864 48.3454 14.8169 48.6215 15.0954C48.8976 15.374 49.2262 15.5951 49.5882 15.746C49.9503 15.8969 50.3386 15.9746 50.7309 15.9746C51.1231 15.9746 51.5114 15.8969 51.8735 15.746C52.2355 15.5951 52.5641 15.374 52.8402 15.0954C53.1164 14.8169 53.3346 14.4864 53.4823 14.123C53.63 13.7597 53.7043 13.3706 53.7008 12.9784V3.42624C53.7 2.63883 53.3868 1.88392 52.83 1.32711C52.2733 0.770312 51.5184 0.457096 50.731 0.456183V0.456183Z",
  fill: "#262626"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M121.453 12.9748V3.42235C121.453 1.66384 120.027 0.238281 118.269 0.238281C116.51 0.238281 115.085 1.66384 115.085 3.42235V12.9748C115.085 14.7333 116.51 16.1588 118.269 16.1588C120.027 16.1588 121.453 14.7333 121.453 12.9748Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M118.269 16.3722C117.368 16.3712 116.504 16.0129 115.867 15.3758C115.23 14.7387 114.871 13.8749 114.87 12.9739V3.42173C114.87 2.52045 115.228 1.65608 115.866 1.01877C116.503 0.381471 117.367 0.0234375 118.269 0.0234375C119.17 0.0234375 120.034 0.381471 120.672 1.01877C121.309 1.65608 121.667 2.52045 121.667 3.42173V12.9739C121.666 13.8749 121.308 14.7387 120.671 15.3758C120.033 16.0129 119.17 16.3712 118.269 16.3722V16.3722ZM118.269 0.451672C117.481 0.452767 116.727 0.766064 116.17 1.32285C115.613 1.87963 115.3 2.63444 115.3 3.42173V12.9739C115.3 13.7616 115.612 14.5171 116.169 15.0741C116.726 15.6311 117.482 15.944 118.27 15.944C119.057 15.944 119.813 15.6311 120.37 15.0741C120.927 14.5171 121.24 13.7616 121.24 12.9739V3.42173C121.239 2.63412 120.925 1.87903 120.368 1.3222C119.811 0.765362 119.056 0.45228 118.269 0.451672V0.451672Z",
  fill: "#262626"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M69.1345 67.9304C70.8319 67.9304 72.2078 67.2062 72.2078 66.3129C72.2078 65.4195 70.8319 64.6953 69.1345 64.6953C67.4372 64.6953 66.0613 65.4195 66.0613 66.3129C66.0613 67.2062 67.4372 67.9304 69.1345 67.9304Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M99.8657 67.9304C101.563 67.9304 102.939 67.2062 102.939 66.3129C102.939 65.4195 101.563 64.6953 99.8657 64.6953C98.1684 64.6953 96.7925 65.4195 96.7925 66.3129C96.7925 67.2062 98.1684 67.9304 99.8657 67.9304Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M45.3975 35.1992H27.0708V53.2124H45.3975V35.1992Z",
  fill: "#BDC7F8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M45.3975 58.2188H27.0708V76.232H45.3975V58.2188Z",
  fill: "#BDC7F8"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M45.3975 81.2383H27.0708V99.2515H45.3975V81.2383Z",
  fill: "#BDC7F8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M69.5291 35.1992H51.2024V53.2124H69.5291V35.1992Z",
  fill: "#BDC7F8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M69.5291 58.2188H51.2024V76.232H69.5291V58.2188Z",
  fill: "#BDC7F8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M93.4176 35.1992H75.0908V53.2124H93.4176V35.1992Z",
  fill: "#BDC7F8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M93.4176 58.2188H75.0908V76.232H93.4176V58.2188Z",
  fill: "#BDC7F8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M117.982 35.1992H99.6553V53.2124H117.982V35.1992Z",
  fill: "#BDC7F8"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M117.982 58.2188H99.6553V76.232H117.982V58.2188Z",
  fill: "#BDC7F8"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M69.5291 81.2383H51.2024V99.2515H69.5291V81.2383Z",
  fill: "#BDC7F8"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M93.4176 81.2383H75.0908V99.2515H93.4176V81.2383Z",
  fill: "#BDC7F8"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M141.929 35.1992H123.603V53.2124H141.929V35.1992Z",
  fill: "#BDC7F8"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M141.929 58.2188H123.603V76.232H141.929V58.2188Z",
  fill: "#BDC7F8"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M65.3025 62.4964C65.0796 62.2734 64.7772 62.1482 64.462 62.1482C64.1467 62.1482 63.8444 62.2734 63.6214 62.4964L60.3999 65.7179L57.1784 62.4964C56.9554 62.2734 56.6531 62.1482 56.3378 62.1482C56.0226 62.1482 55.7202 62.2734 55.4973 62.4964C55.2744 62.7193 55.1491 63.0216 55.1491 63.3369C55.1491 63.6522 55.2744 63.9545 55.4973 64.1774L58.7188 67.399L55.4973 70.6205C55.2744 70.8434 55.1491 71.1458 55.1491 71.461C55.1491 71.7763 55.2744 72.0786 55.4973 72.3016C55.7202 72.5245 56.0226 72.6497 56.3378 72.6497C56.6531 72.6497 56.9554 72.5245 57.1784 72.3016L60.3968 69.0831L63.6184 72.3046C63.8413 72.5276 64.1437 72.6528 64.4589 72.6528C64.7742 72.6528 65.0765 72.5276 65.2995 72.3046C65.5224 72.0817 65.6476 71.7794 65.6476 71.4641C65.6476 71.1488 65.5224 70.8465 65.2994 70.6236L62.081 67.4051L65.3056 64.1805C65.4162 64.0698 65.5039 63.9385 65.5637 63.7938C65.6234 63.6492 65.654 63.4943 65.6537 63.3378C65.6534 63.1813 65.6223 63.0265 65.562 62.8821C65.5017 62.7377 65.4135 62.6066 65.3025 62.4964Z",
  fill: "#F15857"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M89.3025 62.6956C89.0796 62.4727 88.7772 62.3474 88.462 62.3474C88.1467 62.3474 87.8444 62.4727 87.6214 62.6956L84.3999 65.9171L81.1784 62.6956C80.9554 62.4727 80.6531 62.3474 80.3378 62.3474C80.0226 62.3474 79.7202 62.4727 79.4973 62.6956C79.2744 62.9185 79.1491 63.2208 79.1491 63.5361C79.1491 63.8514 79.2744 64.1537 79.4973 64.3766L82.7188 67.5982L79.4973 70.8197C79.2744 71.0426 79.1491 71.345 79.1491 71.6603C79.1491 71.9755 79.2744 72.2779 79.4973 72.5008C79.7202 72.7237 80.0226 72.8489 80.3378 72.8489C80.6531 72.8489 80.9554 72.7237 81.1784 72.5008L84.3968 69.2823L87.6184 72.5038C87.8413 72.7268 88.1437 72.852 88.4589 72.852C88.7742 72.852 89.0765 72.7268 89.2995 72.5038C89.5224 72.2809 89.6476 71.9786 89.6476 71.6633C89.6476 71.3481 89.5224 71.0457 89.2994 70.8228L86.081 67.6043L89.3056 64.3797C89.4162 64.2691 89.5039 64.1377 89.5637 63.9931C89.6234 63.8485 89.654 63.6935 89.6537 63.537C89.6534 63.3805 89.6223 63.2257 89.562 63.0813C89.5017 62.9369 89.4135 62.8058 89.3025 62.6956Z",
  fill: "#F15857"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M114.303 39.2971C114.08 39.0742 113.777 38.949 113.462 38.949C113.147 38.949 112.844 39.0742 112.621 39.2971L109.4 42.5187L106.178 39.2971C105.955 39.0742 105.653 38.949 105.338 38.949C105.023 38.949 104.72 39.0742 104.497 39.2971C104.274 39.5201 104.149 39.8224 104.149 40.1377C104.149 40.4529 104.274 40.7553 104.497 40.9782L107.719 44.1997L104.497 47.4213C104.274 47.6442 104.149 47.9466 104.149 48.2618C104.149 48.5771 104.274 48.8794 104.497 49.1024C104.72 49.3253 105.023 49.4505 105.338 49.4505C105.653 49.4505 105.955 49.3253 106.178 49.1024L109.397 45.8839L112.618 49.1054C112.841 49.3283 113.144 49.4536 113.459 49.4536C113.774 49.4536 114.077 49.3283 114.299 49.1054C114.522 48.8825 114.648 48.5801 114.648 48.2649C114.648 47.9496 114.522 47.6473 114.299 47.4243L111.081 44.2059L114.306 40.9813C114.416 40.8706 114.504 40.7392 114.564 40.5946C114.623 40.45 114.654 40.295 114.654 40.1386C114.653 39.9821 114.622 39.8272 114.562 39.6828C114.502 39.5385 114.414 39.4074 114.303 39.2971Z",
  fill: "#F15857"
});

var SvgCalendarNotime = function SvgCalendarNotime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 124,
    viewBox: "0 0 169 124",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarNotime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-notime.639406b4.svg";
export { ForwardRef as ReactComponent };